import type { TableName } from "../database-strings";
import { areTableNamesEqual } from "../generator/description";
import { ArrayMap } from "../support/array-map";
import type { TableKeeper} from "./table-keeper";
import { SimpleTableKeeper } from "./table-keeper";

export class TableKeeperStore<T extends TableKeeper> {
    private readonly _forTable = new ArrayMap<TableName, T>(areTableNamesEqual);
    private readonly _userSpecificForTable = new ArrayMap<TableName, TableKeeper>(areTableNamesEqual);

    constructor(
        private readonly _makeKeeper: (tn: TableName) => T,
        private readonly _withSeparateUserSpecificData: boolean
    ) {}

    public getTableKeeperForTable(tn: TableName): T {
        return this._forTable.getOrSet(tn, () => this._makeKeeper(tn));
    }

    public getUserSpecificTableKeeperForTable(tn: TableName): TableKeeper | undefined {
        if (!this._withSeparateUserSpecificData) return undefined;

        return this._userSpecificForTable.getOrSet(tn, () => new SimpleTableKeeper());
    }
}
